export const PRODUCT_TYPES = {
  SACC: 'SACC',
};
